import { IonContent } from '@ionic/react';
import OrderDetailsScreen, { IOrderDetailsPage, RedirectStatus } from '../../../../pages/OrderDetailsScreen';
import OrderTracker from '../../../../features/orders/components/OrderTracker/OrderTracker';
import { FC, useEffect, useMemo, useState } from 'react';
import { ORDER_PAYMENT_STATUSES, PushNotificationStatus } from '../../../../services/exports/Constants';
import ModalWrapper from '../../components/modals/ModalWrapper';
import ModalHeader from '../../components/modals/ModalHeader';
import { IModal } from '../../router/ModalRouter';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';
import RequestPushNotificationsPermitAlert from '../../alerts/request-push-notifications-permit';
import { useTranslation } from 'react-i18next';

const OrderTrackerPage: FC<Partial<IModal> & IOrderDetailsPage> = ({ closeModal, ...rest }): JSX.Element => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Modals:OrderTracker:OrderTrackerPage',
  });
  const { redirect_status } = rest;
  const [paymentStatus, setPaymentStatus] = useState<ORDER_PAYMENT_STATUSES>(null);
  const { pushNotificationsStatus, insets } = useMobileApp();
  const [showPushNotificationsPermitAlert, setShowPushNotificationsPermitAlert] = useState<boolean>(false);

  useEffect(() => {
    if (
      pushNotificationsStatus !== PushNotificationStatus.Undetermined ||
      redirect_status === RedirectStatus.failed ||
      !redirect_status
    ) {
      return;
    }

    setTimeout(() => {
      setShowPushNotificationsPermitAlert(true);
    }, 1000);
  }, []);

  const contentHeight = useMemo(() => {
    const footerHeight = insets.bottom + 260;

    return window.innerHeight - footerHeight;
  }, [insets]);

  return (
    <>
      <ModalWrapper className="relative h-screen overflow-scroll safe-area">
        <ModalHeader title={t('title')} onClose={closeModal} type="page" />
        <IonContent
          style={{
            height: contentHeight,
          }}
        >
          <OrderDetailsScreen {...rest} closeModal={closeModal} onChangePaymentStatus={setPaymentStatus} />
        </IonContent>
        {paymentStatus !== ORDER_PAYMENT_STATUSES.PENDING && (
          <div className="fixed bottom-0 w-full safe-area-bottom bg-white">
            <OrderTracker />
          </div>
        )}
      </ModalWrapper>
      <RequestPushNotificationsPermitAlert
        isOpen={showPushNotificationsPermitAlert}
        onClose={() => setShowPushNotificationsPermitAlert(false)}
      />
    </>
  );
};

export default OrderTrackerPage;
